// extracted by mini-css-extract-plugin
export var button = "_42-0";
export var icon = "_42-1";